import { jsxs as s, jsx as r } from "react/jsx-runtime";
import { Radio as u } from "./index72.mjs";
import { StyledRadioGroupLabel as n, StyledRadioHelperText as b } from "./styles49.mjs";
import { FormControl as f, RadioGroup as h, Stack as R } from "@mui/material";
import { Typography as y } from "./index59.mjs";
const S = ({
  options: l,
  label: d,
  name: m,
  helperText: e,
  value: p,
  hasError: a = !1,
  disabled: i = !1,
  direction: t = "column",
  ...c
}) => /* @__PURE__ */ s(f, { children: [
  /* @__PURE__ */ r(n, { id: `${d}-radio-buttons-group-label`, children: /* @__PURE__ */ r(y.Overline, { children: d }) }),
  /* @__PURE__ */ r(
    h,
    {
      "aria-describedby": `${d}-radio-buttons-group-label`,
      ...c,
      children: /* @__PURE__ */ r(R, { direction: t, gap: 1, children: l.map((o) => /* @__PURE__ */ r(
        u,
        {
          name: m,
          checked: o.value === p,
          ...o,
          hasError: a,
          disabled: i || o.disabled
        },
        o.value
      )) })
    }
  ),
  e && /* @__PURE__ */ r(b, { $hasError: a, $disabled: i, children: e })
] });
export {
  S as RadioGroup
};
//# sourceMappingURL=index73.mjs.map
